import Dot from '@mui/icons-material/FiberManualRecord'
import PendingI from '@mui/icons-material/Remove'
import { Tooltip } from '@mui/material'
import { INVOICE_STATUS } from '../../../constants'
import {
  CFDIStatusClassnameMap,
  CFDIStatusLabelMap,
} from 'lib/utils/Invoices/invoices.utils'

interface ICFDIStatusProps {
  status: number
  row: any
  addTooltip?: boolean
  returnLabel?: boolean
}

const CFDIStatus = ({
  status,
  row,
  addTooltip = false,
  returnLabel = false,
}: ICFDIStatusProps) => {
  const className = CFDIStatusClassnameMap[status] ?? 'pending'
  const Icon = [
    INVOICE_STATUS.ACTIVE.id,
    INVOICE_STATUS.CANCELED.id,
    INVOICE_STATUS.PENDING.id,
  ].includes(status)
    ? Dot
    : PendingI
  const label = !row?.uuid
    ? 'No timbrado'
    : CFDIStatusLabelMap[status] ?? 'Pendiente'

  return (
    <div className="status-container invoice-status">
      {!returnLabel && addTooltip && (
        <Tooltip title={label}>
          <Icon className={`status-icon ${className}`} color="inherit" />
        </Tooltip>
      )}
      {!addTooltip && (
        <Icon className={`status-icon ${className}`} color="inherit" />
      )}
      {returnLabel && label}
    </div>
  )
}

export default CFDIStatus
